import { formatDate } from "@/utils";

export default [
  {
    prop: "No_",
    label: "No_",
    minWidth: 100,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "CustomerCode",
    label: "Venta a-N",
    minWidth: 170,
    sortable: true,
    fixed: false
  },
  {
    prop: "CustomerName",
    label: "Venta a-Nombre",
    minWidth: 170,
    sortable: true,
    fixed: false
  },
  {
    prop: "NDocument",
    label: "N Document",
    minWidth: 130,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "CedAlm",
    label: "Céd. alm",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "SellerId",
    label: "Cód. vendedor",
    minWidth: 140,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "NCamp",
    label: "N Campaña",
    minWidth: 120,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "DateEmi",
    label: "Fecha emisión",
    minWidth: 140,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: (props) => {
      return formatDate(props.DateEmi, "DD/MM/YYYY");
    }
  },
  {
    prop: "DateEnt",
    label: "Fecha reg",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: (props) => {
      return formatDate(props.DateEnt, "DD/MM/YYYY");
    }
  },
  {
    prop: "IdUser",
    label: "Id. Usuario",
    minWidth: 120,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "Status",
    label: "Estado",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: (props) => {
      if (props.Status) {
        return "CERRADO";
      }
      return "ABIERTO";
    }
  },
  {
    prop: "CurrencyCode",
    label: "Cód. divisa",
    minWidth: 120,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "ShiptoName",
    label: "Envía a-Nombre",
    minWidth: 170,
    sortable: true,
    fixed: false
  },
  {
    prop: "LinPro",
    label: "LIN. PRO",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "CodDep",
    label: "Cod. Dep.",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
  }
];
